import { useGlobalContext } from '~/context/GlobalContext';
import styles from './SendButton.module.css';

const SendButton = ({ textInputRef = null }: any) => {
  const { context, setContext } = useGlobalContext();

  const handleClick = (e: any) => {
    // Tworzenie zdarzenia 'keydown' dla klawisza 'Enter'
    const event = new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      charCode: 13,
      keyCode: 13,
      which: 13,
      bubbles: true, // Wydarzenie może być propagowane w górę przez DOM
    });

    if (textInputRef.current) {
      textInputRef.current.dispatchEvent(event);
      textInputRef.current.value = '';
    }
  }

  return (
    <button
      data-compoent="SendButton"
      className={styles.sendButton}
      onClick={handleClick}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        aria-hidden="true"
      >
        <path
          d="M6.99811 10.2467L7.43298 11.0077C7.70983 11.4922 7.84825 11.7344 7.84825 12C7.84825 12.2656 7.70983 12.5078 7.43299 12.9923L6.99811 13.7533C5.75981 15.9203 5.14066 17.0039 5.62348 17.5412C6.1063 18.0785 7.24961 17.5783 9.53623 16.5779L15.8119 13.8323C17.6074 13.0468 18.5051 12.654 18.5051 12C18.5051 11.346 17.6074 10.9532 15.8119 10.1677L9.53624 7.4221C7.24962 6.42171 6.1063 5.92151 5.62348 6.45883C5.14066 6.99615 5.75981 8.07966 6.99811 10.2467Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};

export default SendButton;
